<template>
  <layout
    :title="$vuetify.breakpoint.smAndUp ? $route.name : 'Gestor'"
    :rotas="rotas"
    :options="options"
    class=""
  >
    <template v-slot:toolbar-search>
      <!-- <Filters :filter="filter" /> -->
      <div style="gap: 6px;" class="pl-3 expande-horizontal">
        <v-menu 
          offset-y 
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :color="$theme.primary"
              small
              id="btn-filters"
              class="fonte fonte-bold"
              dark
              v-bind="attrs"
              v-on="on"
            > 
              Filtros
              <v-icon>
                mdi-filter-variant
              </v-icon>
            </v-btn>
          </template>
          <v-card  class="px-0 mt-1" color="#f2f2f2" style=" border: 1px solid #777; border-radius: 6px; min-height: 85vh;" width="500">
            <div style="gap: 6px;" class="pa-2 pt-3 pb-1 centraliza expande-horizontal wrap">
              <v-flex xs12>
                <div class="expande-horizontal centraliza fonte">
                  <span class="fonte-bold">Filtros</span>
                  <v-spacer></v-spacer>
                  <v-btn @click="closeFilter" icon><v-icon>mdi-close-circle-outline</v-icon></v-btn>
                </div>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  class="fonte"
                  v-model="filter.search"
                  clearable
                  filled
                  label="Incluir Cliente"
                  persistent-hint
                  :hint="`Há ${get_clientes.docs.length} clientes`"
                  placeholder="Busque um cliente"
                  prefix="😊"
                  :items="get_clientes.docs"
                  item-text="nome"
                  item-value="nome"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  class="fonte"
                  v-model="filter.caixa"
                  dense
                  filled
                  clearable
                  prefix="👷🏻‍♂️"
                  placeholder="Busque um vendedor"
                  :hint="`Há ${get_funcionarios.docs.length} vendedores`"
                  persistent-hint
                  label="Incluir Vendedor(a)"
                  :items="get_funcionarios.docs"
                  item-text="nome"
                  item-value="nome"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  class="fonte "
                  v-model="filter.obra"
                  clearable
                  filled
                  dense
                  placeholder="Busque uma obra"
                  :hint="`Há ${get_obras.docs.length} obras`"
                  persistent-hint
                  prefix="🏗"
                  label="Incluir Obra"
                  :items="get_obras.docs"
                  item-text="nome"
                  return-object
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  class="fonte "
                  v-model="filter.status"
                  filled
                  dense
                  clearable
                  placeholder="Escolha uma coluna"
                  persistent-hint
                  :hint="`Há ${kanbanComputed.length} colunas`"
                  prefix="🗃"
                  label="Incluir Coluna"
                  :items="kanbanComputed.filter(kanban => kanban.name !== 'salvo')"
                  item-text="name"
                  item-value="name"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  class="fonte "
                  clearable
                  filled
                  dense
                  placeholder=""
                  prefix="🤝"
                  v-model="filter.status_pagamento"
                  label="Situação do pagamento"
                  :items="['Totalmente Pago', 'Parcialmente Pago', 'Sem Pagamentos Realizados']"
                  item-text="name"
                  item-value="name"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-menu
                  v-model="filterData"
                  :close-on-content-click="false"
                  transition="slide-y-transition"
                  offset-y
                  max-width="450px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      class="fonte "
                      clearable
                      prefix="🗓"
                      filled
                      dense
                      v-model="computedDateFormatted"
                      label="Incluir Data"
                      placeholder="Escolha 1 dia"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filter.data"
                    no-title
                    @input="filterData = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- <v-flex xs3 v-if="filter.obra">
                <v-autocomplete
                  class="fonte ml-1"
                  outlined
                  v-model="filter.comodo"
                  filled
                  dense
                  hide-details
                  label="Cômodo"
                  :items="filter.obra.comodos"
                  item-text="nome"
                  return-object
                ></v-autocomplete>
              </v-flex> -->
            </div>
          </v-card>
        </v-menu>
        <div class="mount-from-bottom" v-if="filter.data || filter.search || filter.obra || filter.caixa || filter.status || filter.status_pagamento" style="gap: 6px; display: flex;">
          <v-btn
            v-if="qtdSelecteds.length > 1"
            @click="printLote"
            dark
            small
            color="blue"
            class="fonte fonte-bold"
            >Imprimir {{ qtdSelecteds.length }} Selecionados <v-icon class="ml-1">mdi-printer </v-icon> </v-btn
          >
          <!-- <v-btn
            v-if="qtdSelecteds.length > 1"
            @click="() => {}"
            dark
            small
            color="orange"
            class="fonte fonte-bold"
            >Cancelar {{ qtdSelecteds.length }} Selecionados <v-icon class="ml-1">mdi-close-circle-outline </v-icon></v-btn
          > -->
          <v-btn
            @click="clearFilters"
            small
            dark
            color="red"
            class="fonte fonte-bold"
            >Limpar Filtros <v-icon class="ml-1">mdi-backspace </v-icon></v-btn
          >
        </div>
      </div>
    </template>
    
    <div
      v-if="!loading"
      style="max-height: calc(100vh - 40px); overflow: auto;"
      class="expande-horizontal column centaliza"
      :class="{ 'orders-manager-dark': isDark, 'orders-manager-light': !isDark }"
    >
      <div
        v-if="(filter.data || filter.status_pagamento || filter.search || filter.obra || filter.caixa || filter.status)"
        style="max-height: calc(100vh - 40px); overflow: auto; height: 100vh; overflow: auto;"
        class="expande-horizontal wrap mount-from-bottom"
      >
        <v-flex xs12 class="px-3">
          <v-simple-table class="mount-from-bottom">
            <template v-slot:default>
              <thead>
                <tr class="text-uppercase font-weight-bold">
                  <th class="text-left" style="width: 20px;"> </th>
                  <th class="text-left"> <v-icon color="primary">mdi-account-circle-outline</v-icon> Cliente</th>
                  <th class="text-left"> Telefone </th>
                  <th class="text-left">Vendedor(a)</th>
                  <th class="text-left">Obra</th>
                  <th class="text-left">Coluna</th>
                  <th class="text-left">Total</th>
                  <th class="text-left">Total Pago</th>
                  <th class="text-left">Data</th>
                </tr>
              </thead>
              <tbody v-if="filteredSales.length > 0">
                <template
                  v-for="(sale, ind) in filteredSales"
                >  
                  <tr
                    class="tr-table fonte"
                    :key="`item-search--${sale._id}`"
                  >
                    <td class="text-left grey--text">
                      <div style="min-height: 30px; display: flex; align-items: center; justify-content: center;">
                        <v-checkbox style="margin-top: -5px;" hide-details v-model="sale.selected"></v-checkbox>
                      </div>
                    </td>
                    <td class="text-left font-weight-bold"  @click="abre_modal_view_gestordepedido(sale)"> <v-icon size="21" class="mr-2" color="primary">mdi-account-circle-outline</v-icon>{{ sale.compra.cliente ? sale.compra.cliente.nome : 'Sem Cliente' }}</td>
                    <td class="text-left grey--text">
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-avatar 
                            v-bind="attrs"
                            v-on="on" style="cursor: pointer;" v-if="sale.compra.cliente.nome " @click="openWhats(sale.compra.cliente)" size="27" :color="sale.compra.cliente.telefone ? 'green darken-1' : 'red darken-1'" >
                              <v-icon size="15" color="#f2f2f2">mdi-whatsapp</v-icon>
                          </v-avatar>
                        </template>
                        <span>Clique para abrir o whatsapp</span>
                      </v-tooltip>
                      {{ sale.compra.cliente.telefone ? sale.compra.cliente.telefone : 'Sem Telefone' }}
                    </td>
                    <td class="text-left grey--text"  @click="abre_modal_view_gestordepedido(sale)">{{ sale.caixa ? sale.caixa.funcionario.nome : 'Não' }}</td>
                    <td class="text-left font-weight-bold">{{ sale.compra.obra ? sale.compra?.obra?.nome : 'Não' }}</td>
                    <td class="text-left grey--text">{{ sale.status_do_pedido === 'salvo' ? 'Recentes': sale.status_do_pedido }}</td>
                    <td class="text-left green--text font-weight-bold">{{ $helper.formataSaldo(sale.compra.preco_total) }}</td>
                    <td class="text-left green--text font-weight-bold">{{ $helper.formataSaldo(sale.compra.total_recebido || 0) }}</td>
                    <td class="text-left">{{ $moment(sale.created_at).format('DD/MM/YYYY') }}</td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
          <div 
            v-if="filteredSales.length === 0"
            class="expande-horizontal mt-3 fonte centraliza column"
            style="background: #f2f2f2; border-radius: 6px; min-height: 40vh;"
          >
            <span style="font-size: 40px">🫣</span>
            <!-- <v-icon color="grey" class="mb-2"> mdi-ballot-outline </v-icon> -->
            <h3 class="grey--text font-weight-light">Não encontramos nada com os filtros selecionados!</h3>
          </div>
        </v-flex>
      </div>
      <div
        v-if="!filter.data && !filter.status_pagamento && !filter.search && !filter.obra && !filter.caixa && !filter.status"
        class="horizontal-scroll mount-from-bottom"
        ref="scrollhorizontal"
        @mousedown="startDrag"
        @touchstart="startDrag"
        @mouseup="endDrag"
        @touchend="endDrag"
      >
        <div 
          class="item-group-kanban-container"
        >
          <button
            icon
            @click="scrollLeft"
            class="scroll-button left"
            ref="leftButton"
          >
            <v-icon color="white">mdi-chevron-left</v-icon>
          </button>
          <draggable
            ref="content"
            ghost-class="kanban-ghost-"
            chosen-class="kanban-column-chosen"
            drag-class="kanban-column-dragging"
            handle=".kanban-selector"
            class="mr-1 expande-horizontal"
            :class="{ 'kanban-board-drag-active': dragActive }"
            style="justify-content: flex-start; align-items: flex-start;"
            @change="changeKanbanFather"
            v-bind="dragOptions"
            @start="dragActive = true"
            @end="dragActive = false"
            v-model="kanbanComputed"
            :group="{ name: 'kanban' }"
          >
            <div
              class="mr-3"
              :class="{
                'item-group-kanban-maximized': !mouseIsDown,
                'item-group-kanban-minimized': mouseIsDown
              }"
              v-for="kanban in kanbans"
              :key="kanban._id"
            >
              <KanbanColumn
                :group="kanban"
                :list="kanban.kanbans"
                :value="kanban.kanbans"
                :deleteKanban="deleteKanban"
                :itemKanbanChange="itemKanbanChange"
              />
            </div>
            <div
              class="new-kanban-slot mr-3"
              :class="{
                'item-group-kanban-maximized': !mouseIsDown,
                'item-group-kanban-minimized': mouseIsDown
              }"
            >
              <div
                id="new_kanbar"
                class="new-kanban-column item-group-kanban ml-0"
                :class="{ 'new-kanban-column-dark': isDark, 'new-kanban-column-light': !isDark }"
              >
                <button
                  v-if="!new_kanban_form"
                  type="button"
                  class="new-kanban-action"
                  @click="openNewKanBanForm"
                >
                  <span class="new-kanban-icon">
                    <v-icon size="20">mdi-plus</v-icon>
                  </span>
                  <span class="new-kanban-copy">
                    <strong>Novo fluxo</strong>
                    <small>Crie uma etapa para organizar suas vendas</small>
                  </span>
                </button>
                <v-form v-if="new_kanban_form" ref="formNewKanban" class="new-kanban-form">
                  <v-flex xs12>
                    <div class="new-kanban-form-body expande-horizontal centraliza column pa-3">
                      <v-color-picker
                        v-model="new_kanban.color"
                        hide-inputs
                        class="new-kanban-color-picker mb-3"
                      ></v-color-picker>
                      <v-text-field
                        v-model="new_kanban.name"
                        placeholder="Informe o nome"
                        dense
                        outlined
                        @keyup.enter.prevent="createKanban"
                        autofocus
                        :rules="[v => !!v || 'Campo obrigatório']"
                      ></v-text-field>
                      <div class="expande-horizontal centraliza">
                        <v-btn
                          @click="new_kanban_form = false"
                          text
                          small
                          class="fonte mr-3 fonteMini"
                          dark
                          >Cancelar</v-btn
                        >
                        <v-btn
                          @click="createKanban"
                          outlined
                          class="fonte font-weight-bold"
                          dark
                          >Criar</v-btn
                        >
                      </div>
                    </div>
                  </v-flex>
                </v-form>
              </div>
            </div>
          </draggable>
          <button
            @click="scrollRight"
            class="scroll-button right"
            ref="rightButton"
          >
            <v-icon color="white">mdi-chevron-right</v-icon>
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="qtdSelecteds.length > 1"
      v-show="in_printing"
      id="print-html-lote"
      style="width: 100%; padding: 0px; display: flex; flex-direction: column; flex-wrap: wrap;"
    >
      <!-- cabeçalho -->
      <div
        style="display: flex; justify-content: space-between; flex-direction: row; flex-wrap: nowrap; width: 100%;"
      >
        <img :style="`min-height: 55px !important; max-height: 55px !important;`" :src="getLoggedUser.tenant[0].profileImage" alt="" />
        <div style="display: flex; align-items: center; flex-direction: column; padding-right: 7px; padding-left: 7px; ">
          <span class="font-head-title">
            {{ getLoggedUser.tenant[0].nome }}
          </span>
          <span class="font-head-subtitle">
            CNPJ: {{ getLoggedUser.tenant[0].cnpj }}
          </span>
          <span
            v-if="getLoggedUser.tenant[0].address"
            class="font-head-subtitle"
          >
            {{ getLoggedUser.tenant[0].address.formatted_address }}
          </span>
          <span
            class="font-head-subtitle"
            v-if="getLoggedUser.tenant[0].phone"
          >
            {{ getLoggedUser.tenant[0].phone }}
          </span>
        </div>
        <div
          class="font-head-subtitle"
          style="font-size: 9pt;display: flex; width: 15%; justify-content: center;"
        >
          {{ getLoggedUser.tenant[0].receipt_config.top_right_text }} 
        </div>
      </div>
      <div
        style="margin-top: 12px;display: flex; justify-content: center; flex-wrap: wrap; width: 100%;"
      >
        <span class="font-title">{{ qtdSelecteds.length }} PROPOSTAS</span>
      </div>
      <!-- Tabela -->
      <div
        style="display: flex; flex-wrap: wrap; width: 100% !important; margin-top: 6px; margin-bottom: 6px; padding: 0px;"
      >
        <template v-for="(lastSell, indexLastSell) in qtdSelecteds">
          <table
            :key="`${lastSell._id}-${indexLastSell}`"
            style="width: 100% !important; background: #f0f0f0; margin-bottom: 12px;"
          >
            <div
              style="padding: 6px; padding-left: 0px; padding-right: 0px; display: flex; width: 100%; flex-direction: column; flex-wrap: wrap; width: 100%;"
            >
              <div style="display: flex; width: 100%;" v-if="lastSell.compra.cliente">
                <span class="font-head-title" style="margin-right: 18px;">
                  Cliente:
                </span>
                <div style="padding-left: 2px; display: flex; min-width: 90%; border-bottom: 1px solid #f2f1f1;">
                  <span class="font-head-subtitle">
                    {{ lastSell.compra.cliente.nome }}       
                  </span>
                </div>
              </div>
              <div style="display: flex; width: 100%; margin-top: 4px;" v-if="lastSell.compra.cliente && lastSell.compra.cliente.telefone">
                <span class="font-head-title" style="margin-right: 6px;">
                  Telefone:
                </span>
                <div style="padding-left: 2px; display: flex; min-width: 90%; border-bottom: 1px solid #f2f1f1;">
                  <span class="font-head-subtitle">
                    {{ lastSell.compra.cliente.telefone }}
                  </span>
                </div>
              </div>
              <div style="display: flex; width: 100%; margin-top: 4px;" v-if="lastSell.compra.obra">
                <span class="font-head-title" style="margin-right: 6px;">
                  Obra:
                </span>
                <div style="padding-left: 2px; display: flex; min-width: 90%; border-bottom: 1px solid #f2f1f1;">
                  <span class="font-head-subtitle">
                    {{ lastSell.compra.obra.nome }}, {{ lastSell.compra.obra.comodos.length }} cômodos.
                  </span>
                </div>
              </div>
            </div>
            <template>
                <tr
                  class="tr-table"
                  style="width: 100%; background: #f7f7f7; border: 1px solid #f0f0f0;"
                >
                  <td
                    style="padding-right: 2px; text-align: center; padding-left: 2px; color: #878686; border-right: 1px solid #D2D4CF;"
                  >
                    <span class="font-head-title">
                      QTD
                    </span>
                  </td>
                  <td
                    style="padding-right: 10px; padding-left: 10px; color: #878686; border-right: 1px solid #D2D4CF;"
                  >
                    <span class="font-head-title">
                      D I S C R I M I N A Ç Ã O
                    </span>
                  </td>
                  <td
                    style="padding-right: 10px; padding-left: 10px; color: #878686; border-right: 1px solid #D2D4CF;"
                  >
                    <span class="font-head-title">
                      MEDIDA
                    </span>
                  </td>
                  <td
                    style="padding-right: 10px; padding-left: 10px; color: #878686; border-right: 1px solid #D2D4CF;"
                  >
                    <span class="font-head-title">
                      UN
                    </span>
                  </td>
                  <td
                    style="padding-right: 10px; padding-left: 10px; color: #878686; border-right: 1px solid #D2D4CF;"
                  >
                    <span class="font-head-title">
                      VALOR
                    </span>
                  </td>
                  <td
                    style="color: #878686;padding-right: 10px; padding-left: 10px; "
                  >
                    <span class="font-head-title">
                      TOTAL
                    </span>
                  </td>
                </tr>
                <template
                  v-for="(item, i2) in lastSell.compra.produtos"
                >
                  <tr
                    style="background: #cccaca; border-bottom: 3px dashed #cccaca;"
                    :key="`desc-perso-${i2}-ls-${indexLastSell}`"
                  >
                    <td
                      class="fonte fonte-micro"
                      style="color: #cccaca; padding-right: 10px; padding-left: 10px;"
                    >
                      <span class="font-head-subtitle">
                        ---
                      </span>
                    </td>
                    <td
                      class="fonte fonte-micro"
                      style="color: #cccaca;padding-right: 10px; padding-left: 10px;"
                    >
                      <span class="font-head-title">
                        {{
                          item.descricao_personalizada
                            ? item.descricao_personalizada
                            : item.nome
                        }} {{ item.comodo ? `- ${item.comodo}` : "" }}
                      </span>
                    </td>
                    <td style="color: #cccaca"> <span class="font-head-subtitle"> --- </span> </td>
                    <td style="color: #cccaca"> <span class="font-head-subtitle"> --- </span> </td>
                    <td style="color: #cccaca"> <span class="font-head-subtitle"> --- </span> </td>
                    <td style="color: #cccaca"> <span class="font-head-subtitle"> --- </span> </td>
                  </tr>
                  <tr
                    v-for="(ficha, i) in item.ficha_tecnica"
                    class="tr-table"
                    style="background: #f0f0f0; width: 100%;"
                    :key="`item-ficha-prod-${i}-${i2}-lastsell-${indexLastSell}`"
                    v-show="ficha.quantity && ficha.quantity >= 1"
                  >
                    <td
                      class="fonte fonte-micro"
                      style="color: #f7f7f7; text-align: center;"
                    >
                      <span class="font-head-title">
                        {{ ficha.quantity }}
                      </span>
                    </td>
                    <td
                      class="fonte fonte-micro"
                      style="padding-right: 10px; padding-left: 10px;"
                    >
                      <span class="font-head-subtitle">
                        {{ ficha.descricao ? ficha.descricao : "" }} -
                        {{ item.nome }}
                      </span>
  
                    </td>
                    <td
                      class="fonte fonte-bold"
                      style="padding-right: 10px; padding-left: 10px; text-wrap: nowrap;"
                      v-if="ficha.comprimento || ficha.largura"
                    >
                      <span class="font-head-subtitle">
                        {{ formatMeasure(ficha.comprimento) }} x {{ formatMeasure(ficha.largura) }}
                      </span>
                    </td>
                    <td
                      class="fonte fonte-bold"
                      style="color: #494949;padding-right: 10px; padding-left: 10px;"
                      v-else
                    >
                      <span class="font-head-subtitle">
                        ##
                      </span>
                    </td>
                    <td
                      class="fonte fonte-bold"
                      style="color: #494949;padding-right: 10px; padding-left: 10px;"
                    >
                      <span class="font-head-subtitle">
                        {{ verifyUnit(ficha) }}
                      </span>
                    </td>
                    <td
                      class="fonte fonte-bold"
                      style="padding-right: 10px; padding-left: 10px; text-wrap: nowrap;"
                    >
                      <span class="font-head-subtitle">
                        {{ $helper.formataSaldo(ficha.preco) }}
                      </span>
                    </td>
                    <td
                      class="fonte fonte-micro"
                      style="padding-right: 10px; padding-left: 10px;text-align: right; text-wrap: nowrap;"
                    >
                      <span class="font-head-subtitle">
                        {{
                          $helper.formataSaldo(parseFloat(ficha.total))
                        }}
                      </span>
                    </td>
                  </tr>
                  <tr class="tr-table" style="width: 100%; background: #cccaca; border: 1px solid #f0f0f0;">
                    <td style="color: #878686"> <span class="font-head-subtitle"> --- </span> </td>
                    <td style="color: #878686"> <span class="font-head-subtitle"> --- </span> </td>
                    <td style="color: #878686"> <span class="font-head-subtitle"> --- </span> </td>
                    <td style="color: #878686"> <span class="font-head-subtitle"> --- </span> </td>
                    <td style="color: #878686"> <span class="font-head-title"> TOTAL </span> </td>
                    <td style="color: #878686"> <span class="font-head-title"> {{ $helper.formataSaldo(lastSell.compra.preco_total) }} </span> </td>
                  </tr>
                </template>
            </template>
          </table>
        </template>
      </div>
      <!-- valores -->
      <div
        style="padding: 3px;padding-right: 6px; padding-left: 6px;display: flex; justify-content: space-between; flex-wrap: nowrap; width: 100%;"
      >
        <table>
          <tr>
            <td style="width: 100%;"></td>
            <td style="padding-right: 6px; text-align: right;text-wrap: nowrap;">
              <span class="font-head-title">ACABAMENTO R$</span>
            </td>
            <td style="text-align: right;padding-right: 14px;">
              <span style="text-wrap: nowrap;" class="font-head-subtitle">
                + {{ $helper.formataSaldo(qtdSelectedsTotal.acabamento || 0) }}
              </span>
            </td>
          </tr>
          <tr>
            <td style="width: 100%;"></td>
            <td style="padding-right: 6px; text-align: right;text-wrap: nowrap;">
              <span class="font-head-title">TOTAL SEM DESCONTO R$</span>
            </td>
            <td style="text-align: right;padding-right: 10px;">
              <span style="text-wrap: nowrap;text-align: right;" class="font-head-subtitle bg-texts">
                = {{ $helper.formataSaldo(qtdSelectedsTotal.subtotal) }}
              </span>
            </td>
          </tr>
          <tr>
            <td style="width: 100%;"></td>
            <td style="padding-right: 6px; text-align: right;text-wrap: nowrap;border-bottom: 1px solid #c6c6c6;">
              <span class="font-head-title">
              DESCONTO, R$</span>
            </td>
            <td style="text-align: right;padding-right: 14px;border-bottom: 1px solid #c6c6c6;">
              <span style="text-wrap: nowrap;text-align: right;" class="font-head-subtitle">
                - {{ $helper.formataSaldo(qtdSelectedsTotal.desconto || 0) }}
              </span>
            </td>
          </tr>
          <tr>
            <td style="width: 100%;"></td>
            <td style="padding-right: 6px; text-align: right; text-wrap: nowrap;">
              <span class="font-head-title">TOTAL COM DESCONTO R$</span>
            </td>
            <td style="text-align: right;padding: 10px;">
              <span style="text-wrap: nowrap;text-align: right;" class="font-head-subtitle bg-texts">
                = {{ $helper.formataSaldo(qtdSelectedsTotal.preco_total) }}
              </span>
            </td>
          </tr>
        </table>
      </div>
      <!-- campo pra assinar -->
      <div
        style="color: #bebcbc; margin-top: 36px; display: flex; width: 100%; justify-content: center;"
      >
        _________________________________________________________________
      </div>
      <div
        style="display: flex; width: 100%; justify-content: center;"
      >
        <span class="font-head-title">
          AUTORIZO
        </span>
      </div>
      <!-- Informações das propostas -->
      <div
        style="margin-bottom: 12px; margin-top: 4px; flex-direction: column; display: flex; width: 100%;"
      >
        <div style="display: flex; width: 100%; justify-content: center;">
          <span v-if="getLoggedUser.tenant[0].receipt_config && getLoggedUser.tenant[0].receipt_config.show_header_text" class="font-head-subtitle">
            {{ getLoggedUser.tenant[0].receipt_config.show_header_text.text }}
          </span>
        </div>
        <table>
          <tr>
            <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">DATA DE EMISSÃO</th>
            <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">OBSERVAÇÕES</th>
            <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">Nº DO DOCUMENTO</th>
          </tr>

          <tr>
            <td style="border-bottom: 1px solid #e2e0e0 !important;">
              <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                {{ $moment().format("DD/MM/YYYY HH:mm") }}
              </span>
            </td>
            <td style="border-bottom: 1px solid #e2e0e0 !important;">
              <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">{{ getLoggedUser.tenant[0].receipt_config.short_obs }}</span>
            </td>
            <td style="max-width: 70px; border-bottom: 1px solid #e2e0e0 !important;">
              <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">LOTE</span>
            </td>
          </tr>

          <tr>
            <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">VALIDADE DA PROPOSTA</th>
            <th style="padding-left: 6px;background: #fff;">
              <span style="display: flex; width: 100%;" class="font-head-subtitle">
                Atenciosamente,
              </span>
            </th>
            <th>*</th>
          </tr>

          <tr style="margin-bottom: 0px; padding-bottom: 0px;">
            <td style="border-bottom: 1px solid #e2e0e0 !important;">
              <span style="display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                {{ proposalValidity(lastSell) }}
              </span>
            </td>
            <td style="border-bottom: 1px solid #e2e0e0 !important;">
              <span style="padding-left: 6px; display: flex; width: 100%; align-items: center;" class="font-head-subtitle">
                <span>{{ getLoggedUser.nome }}</span>
              </span>
            </td>
            <td style="max-width: 70px; border-bottom: 1px solid #e2e0e0 !important;">
              <span style="font-size: 9pt; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                {{ getLoggedUser.tenant[0].receipt_config.bottom_right_text }}
              </span>
            </td>
          </tr>
        </table>
        <div style="display: flex; width: 100%; justify-content: center;">
          <span v-if="getLoggedUser.tenant[0].receipt_config && getLoggedUser.tenant[0].receipt_config.show_footer_text" class="font-head-subtitle">
            {{ getLoggedUser.tenant[0].receipt_config.show_footer_text.text }}
          </span>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import KanbanColumn from "../components/SalesList";
import SaleItem from "../components/SaleItem";
import SaleItemMobile from "../components/SaleItemMobile";
import Filters from "../components/Filters";
import { EventBus } from "@/main.js";
import draggable from "vuedraggable";
import { formatMeasure } from "@/apps/shared/utils/measurements";
import { printBudget } from "@/apps/shared/services/printSaleDocuments";
export default {
  data() {
    return {
      in_printing: false,
      options: [
        {
          icon: "mdi-sync",
          nome: "Sincronizar",
          action: () => this.listar_gestordepedidos()
        }
      ],
      loading: false,
      dragActive: false,
      saleRealtimeRefreshTimer: null,
      dragOptions: {
        animation: 220,
        easing: "cubic-bezier(0.2, 0, 0, 1)",
        disabled: false,
        ghostClass: "kanban-ghost-",
        chosenClass: "kanban-column-chosen",
        dragClass: "kanban-column-dragging",
        forceFallback: true,
        fallbackOnBody: true,
        fallbackTolerance: 8
      },
      checking: false,
      showButtons: false,
      isDragging: false,
      mouseIsDown: false,
      startDragX: 0,
      startScrollLeft: 0,
      payment_sys_config: {},
      receipt: {
        show_my_address: { active: true },
        show_my_logo: { active: true },
        show_my_qrcode: { active: true },
        show_client_details: { active: true },
        show_header_text: { active: true, text: "" },
        show_footer_text: { active: true, text: "" }
      },
      new_kanban_form: false,
      new_kanban: {
        name: "",
        items: []
      },
      filterData: false,
      filter: {
        search: "",
        caixa: "",
        status: "",
        status_pagamento: "",
        obra: null,
        comodo: null,
        data: null
      },
      kanbans: [],
      rotas: [
        {
          name: "Início",
          path: "/dashboard"
        },
        {
          name: "Vendas",
          path: "/gestordepedidos"
        }
      ],
      logoBase64: "",
      selectedKanban: {
        name: "",
        kanbans: []
      }
    };
  },
  components: {
    Filters,
    SaleItem,
    SaleItemMobile,
    draggable,
    KanbanColumn
  },
  computed: {
    computedDateFormatted: {
      get() {
        if (!this.filter.data) return '';
        return this.$moment(this.filter.data).format('DD/MM/YYYY')
      },
      set(value) {
        return
        // this.filter.data = value
      }
    },
    isDark() {
      return localStorage.dark === "true";
    },
    ...mapGetters(["getLoggedUser", "get_gestordepedidos", "get_obras", "get_clientes", "get_funcionarios"]),
    // filteredSales() {
    //   let filteredSales = this.get_gestordepedidos.docs;
    //   if (this.filter.search || this.filter.obra || this.filter.comodo) {
    //     const searchObjects = (arr, searchValue) => {
    //       return arr.filter(obj => {
    //         if (obj.compra.cliente) {
    //           return Object.keys(obj.compra.cliente).some(key => {
    //             const value = obj.compra.cliente[key];
    //             if (
    //               typeof value === "string" &&
    //               value.toLowerCase().includes(searchValue.toLowerCase())
    //             ) {
    //               return true;
    //             } else if (obj.id_transacao == searchValue) {
    //               return true;
    //             } else {
    //               return false;
    //             }
    //           });
    //         } else if (this.filter.obra) {
              
    //         } else {
    //           return false
    //         }
    //       });
    //     };
    //     const res = searchObjects(filteredSales, this.filter.search);
    //     return res;
    //   } else {
    //     return [];
    //   }
    // },
    filteredSales() {
      var docs = this.get_gestordepedidos && this.get_gestordepedidos.docs;
      var sales = Array.isArray(docs) ? docs : [];

      // ===================================================
      // NORMALIZAÇÃO DOS FILTROS
      // ===================================================
      var search = this.filter.search
        ? String(this.filter.search).toLowerCase()
        : "";

      var caixa = this.filter.caixa
        ? String(this.filter.caixa).toLowerCase()
        : "";

      var status = this.filter.status
        ? String(this.filter.status).toLowerCase()
        : "";
      var status_pagamento = this.filter.status_pagamento;

      var filtro_data = this.filter.data;
      // Se obra é objeto, usamos obra.nome
      var filterObraName = "";
      if (this.filter.obra) {
        if (typeof this.filter.obra === "string") {
          filterObraName = this.filter.obra.toLowerCase();
        } else if (typeof this.filter.obra === "object") {
          filterObraName = String(this.filter.obra.nome || "").toLowerCase();
        }
      }

      var filterComodo = this.filter.comodo
        ? String(this.filter.comodo).toLowerCase()
        : "";

      // Se nada foi filtrado → retorno vazio (igual seu comportamento original)
      if (!filtro_data && !status_pagamento && !status && !caixa && !search && !filterObraName && !filterComodo) {
        return [];
      }

      // ===================================================
      // FUNÇÃO DE MATCH SEGURA
      // ===================================================
      function matches(value, term) {
        if (!term) return false;
        if (value === undefined || value === null) return false;
        return String(value).toLowerCase().includes(term);
      }

      // ===================================================
      // FUNÇÕES DE VERIFICAÇÃO INDIVIDUAL
      // ===================================================

      // ----- verifica match do filter.search -----
      function matchesSearch(venda) {
        if (!search) return true; // Se não pediu search, está OK

        // CLIENTE
        var cliente = venda?.compra?.cliente || null;
        if (cliente) {
          // for (var k in cliente) {
            if (matches(cliente.nome, search)) return true;
          // }
        }


        // PRODUTOS
        // var produtos = venda?.compra?.produtos || [];
        // for (var i = 0; i < produtos.length; i++) {
        //   var p = produtos[i];

        //   if (matches(p?.nome, search)) return true;
        //   if (matches(p?.descricao_personalizada, search)) return true;
        //   if (matches(p?.type, search)) return true;

        //   var obra = p?.obra;
        //   if (obra) {
        //     if (matches(obra.nome, search)) return true;
        //     if (matches(obra.id_obra, search)) return true;

        //     if (Array.isArray(obra.comodos)) {
        //       for (var c = 0; c < obra.comodos.length; c++) {
        //         if (matches(obra.comodos[c], search)) return true;
        //       }
        //     }
        //   }
        // }

        return false;
      }
      function matchesCaixa(venda) {
        if (!caixa) return true; // Se não pediu search, está OK

        // CAIXA
        var caixaToSearch = venda?.caixa ? venda.caixa.funcionario : null;
        
          if (matches(caixaToSearch.nome, caixa)) return true;
          // if (matches(caixaToSearch.funcionario.cpf, caixa)) return true;
        return false;
      }

      const self = this;
      
      function matchesData(venda) {
        if (!filtro_data) return true; // Se não pediu search, está OK
        const dataVenda = self.$moment(venda?.created_at).format('YYYY-MM-DD');
        const fataFiltro = self.$moment(filtro_data).format('YYYY-MM-DD');

        console.log(dataVenda, fataFiltro);
        if (dataVenda === fataFiltro) return true;
        return false;
      }
      
      function matchesPagamento(venda) {
        if (!status_pagamento) return true; // Se não, está OK

        const valor_total = parseFloat(venda?.compra?.preco_total) || 0;
        const total_pago = parseFloat(venda?.compra?.total_recebido) || 0;

        if (total_pago >= valor_total) {
          if (status_pagamento === 'Totalmente Pago') return true;
        } else if(total_pago > 0 && total_pago < valor_total) {
          if (status_pagamento === 'Parcialmente Pago') return true;
        } else if (total_pago === 0) {
          if (status_pagamento === 'Sem Pagamentos Realizados') return true;
        }

        return false;
      }
      
      function matchesStatus(venda) {
        if (!status) return true; // Se não pediu search, está OK

        var statusToSearch = venda?.status_do_pedido;
        if (matches(statusToSearch, status)) return true;
        return false;
      }

      // ----- verifica match do filter.obra -----
      function matchesObra(venda) {
        if (!filterObraName) return true;

        // var produtos = venda?.compra?.produtos || [];

        // for (var i = 0; i < produtos.length; i++) {
        //   var obra = produtos[i]?.obra;
        //   if (!obra) continue;

        //   if (matches(obra.nome, filterObraName)) return true;
        // }
        var obra = venda?.compra?.obra || {};
        
        if (matches(obra.nome, filterObraName)) return true;
        return false;
      }

      // ----- verifica match do filter.comodo -----
      function matchesComodo(venda) {
        if (!filterComodo) return true;

        var produtos = venda?.compra?.produtos || [];

        for (var i = 0; i < produtos.length; i++) {
          var p = produtos[i];

          // comodo direto do produto
          if (matches(p?.comodo, filterComodo)) return true;

          // comodos da obra
          var obra = p?.obra;
          if (obra && Array.isArray(obra.comodos)) {
            for (var c = 0; c < obra.comodos.length; c++) {
              if (matches(obra.comodos[c], filterComodo)) return true;
            }
          }
        }

        return false;
      }

      // ===================================================
      // FILTRAGEM FINAL — **TODOS OS FILTROS DEVEM SER TRUE**
      // ===================================================
      return sales.filter(function (venda) {
        return (
          matchesSearch(venda) &&
          matchesObra(venda) &&
          // matchesComodo(venda) && 
          matchesCaixa(venda) &&
          matchesStatus(venda) &&
          matchesPagamento(venda) &&
          matchesData(venda)
        );
      });
    },
    qtdSelecteds() {
      const items = this.get_gestordepedidos.docs.filter(item => item.selected);
      return items;
    },
    qtdSelectedsTotal() {
      const sales = this.qtdSelecteds;
      let acabamento = 0;
      let subtotal = 0;
      let desconto = 0;
      let preco_total = 0;
      
      sales.forEach(sale => {
        acabamento += sale.compra.acabamento;
        subtotal += sale.compra.subtotal;
        desconto += sale.compra.desconto;
        preco_total += sale.compra.preco_total;
      });

      return {
        acabamento,
        subtotal,
        desconto,
        preco_total
      }
    },

    kanbanComputed: {
      get() {
        const orderByIndex = (arr, key) => {
          return arr.sort((a, b) => {
            return a[key] - b[key];
          });
        };
        const kanbans = orderByIndex(this.kanbans, "index");
        return kanbans;
      },
      set(val) {
        console.log("setted", val);
        const orderByIndex = (arr, key) => {
          return arr.sort((a, b) => {
            return a[key] - b[key];
          });
        };
        const kanbans = orderByIndex(val, "index");
        return kanbans;
      }
    }
  },
  methods: {
    formatMeasure,
    proposalValidity(sale) {
      if (sale && sale.proposal_expires_at) {
        return this.$moment(sale.proposal_expires_at).format("DD/MM/YYYY HH:mm");
      }
      const tenant = this.getLoggedUser.tenant && this.getLoggedUser.tenant[0] || {};
      const days = tenant.receipt_config && tenant.receipt_config.validate_proposal_in_days || 7;
      return this.$moment(sale && sale.created_at).add(days, "days").format("DD/MM/YYYY HH:mm");
    },
    ...mapActions([
      "listar_gestordepedidos",
      "listar_funcionarios",
      "listar_clientes",
      "abre_modal_view_gestordepedido",
      "listar_obras"
    ]),
    mouseLeaveFilter() {
      // document.getElementById("btn-filters").click();
    },
    handleSaleRealtimeUpdated() {
      clearTimeout(this.saleRealtimeRefreshTimer);
      this.saleRealtimeRefreshTimer = setTimeout(() => {
        this.listar_gestordepedidos();
      }, 400);
    },
    closeFilter() {
      document.getElementById("btn-filters").click();
    },
    verifyUnit(item) {
      if (
        (item.type === "Peça Secundária" || item.type === "Peça Principal") &&
        parseFloat(item.largura) <= 0.1
      ) {
        return "ML";
      } else if (
        (item.type === "Peça Secundária" || item.type === "Peça Principal") &&
        parseFloat(item.largura) > 0.1
      ) {
        return "M²";
      } else if (item.type === "Acabamento") {
        return "UND";
      }
    },
    clearFilters() {
      this.filter = { data: null, search: null, obra: null, caixa: null, status: null, status_pagamento: null };
      this.get_gestordepedidos.docs = this.get_gestordepedidos.docs.map(item => {
        delete item.selected;
        return item;
      });
    },
    openWhats(client) {
      window.open(
        `https://api.whatsapp.com/send?phone=55${client.telefone}&text=Olá, ${client.nome}!`
      );
    },
    colorGroup(group) {
      if (group.color) {
        return group.color.hex;
      } else {
        return "#333";
      }
    },
    selectSalesByKanban(kanban) {
      //trabalha apenas para o mobile 28/10 23:18
      this.selectedKanban = kanban || {
        kanbans: [],
        name: ""
      };
    },
    orderByKey(arr, key) {
      return arr.sort((a, b) => {
        return a[key] - b[key];
      });
    },
    // updateGroupsDinamic(groupsToUpdate) {
    //   if (groupsToUpdate) {
    //     groupsToUpdate.map(group => {
    //       EventBus.$emit(group.groupName, group.data);
    //     });
    //   }
    // },
    async itemKanbanChange_old(event, sale) {
      const newStatus = event.to.__vue__.$attrs["group-name"];
      const oldStatus = event.from.__vue__.$attrs["group-name"];
      const group = document.getElementsByClassName(`group-sale-${newStatus}`);
      const old_group = document.getElementsByClassName(
        `group-sale-${oldStatus}`
      );
      const getElementsFromGroup = group => {
        let newElementsOrder = [];
        for (var i = 0; i < group.length; i++) {
          var elemento = group[i];
          for (var y = 0; y < elemento.childNodes.length; y++) {
            const child = elemento.childNodes[y];
            const id = child.getAttribute("data-id");
            newElementsOrder.push(id);
          }
        }
        return newElementsOrder;
      };

      const getElement = group => {
        let res = {
          element: null,
          index: null
        };
        for (var i = 0; i < group.length; i++) {
          var elemento = group[i];
          if (elemento.childNodes.length === 2) {
            res.element = elemento;
            res.dataIndex = parseInt(i);
          }
        }
        return res;
      };
      const getNewIndex = groupRes => {
        let res = {
          newIndex: null,
          oldIndex: null,
          newGroup: newStatus,
          oldGroup: oldStatus
        };
        const groupFinded = groupRes.element;

        if (groupFinded && groupFinded.childNodes) {
          for (var i = 0; i < groupFinded.childNodes.length; i++) {
            var elemento = groupFinded.childNodes[i];
            if (elemento.classList.contains(`sale-id-${sale._id}`)) {
              res.oldIndex = parseInt(elemento.getAttribute("data-index"));
              if (i === 0) {
                res.newIndex = groupRes.dataIndex;
              } else if (i === 1) {
                res.newIndex = groupRes.dataIndex + 1;
              }
            }
          }
        } else {
          res.newIndex = 0;
        }
        return res;
      };

      const resIndex = getNewIndex(getElement(group), sale);

      const isSameGroup = newStatus === oldStatus;

      const updateOldGroup = async (group, sale) => {
        let newItens = group.kanbans.filter(item => item._id !== sale._id);
        const orderByIndex = (arr, key) => {
          return arr.sort((a, b) => {
            return a[key] - b[key];
          });
        };
        let normalizedItems = orderByIndex(newItens, "kanban_order");
        let itensToUpdate = normalizedItems.map((item, index) => {
          return {
            updateMany: {
              filter: { _id: item._id },
              update: {
                $set: {
                  kanban_order: index,
                  status_do_pedido: item.status_do_pedido
                }
              }
            }
          };
        });
        return itensToUpdate;
      };

      const updateNewGroup = async (group, sale) => {
        let localSaleToBeReplaced = group.kanbans.filter(
          item => item.kanban_order === resIndex.newIndex
        )[0];

        let newItens = group.kanbans.filter(item => item._id !== sale._id);
        let itensToUpdate = [];
        const orderByIndex = (arr, key) => {
          return arr.sort((a, b) => {
            return a[key] - b[key];
          });
        };

        let normalizedItems = orderByIndex(newItens, "kanban_order");
        let fired = false;
        normalizedItems.map((item, index) => {
          if (index === resIndex.newIndex && !fired) {
            itensToUpdate.push({
              updateMany: {
                filter: { _id: sale._id },
                update: {
                  $set: {
                    kanban_order: index,
                    status_do_pedido: item.status_do_pedido
                  }
                }
              }
            });
            itensToUpdate.push({
              updateMany: {
                filter: { _id: localSaleToBeReplaced._id },
                update: {
                  $set: {
                    kanban_order: index + 1,
                    status_do_pedido: item.status_do_pedido
                  }
                }
              }
            });
            fired = true;
          } else if (fired) {
            itensToUpdate.push({
              updateMany: {
                filter: { _id: item._id },
                update: {
                  $set: {
                    kanban_order: index + 1,
                    status_do_pedido: item.status_do_pedido
                  }
                }
              }
            });
          } else {
            itensToUpdate.push({
              updateMany: {
                filter: { _id: item._id },
                update: {
                  $set: {
                    kanban_order: index,
                    status_do_pedido: item.status_do_pedido
                  }
                }
              }
            });
          }
        });
        return itensToUpdate;
      };

      const updateSameGroup = async group => {
        const groupName = newStatus;
        const newOrderElements = getElementsFromGroup(group);
        const res = newOrderElements.map((id, index) => {
          return {
            updateMany: {
              filter: { _id: id },
              update: {
                $set: {
                  kanban_order: index,
                  status_do_pedido: groupName
                }
              }
            }
          };
        });
        return {
          itemsToBeReplacelocal: [], //verificar se é necessário
          itemsToBeUpdated: res
        };
      };

      const updateLocalItems = async itemsToUpdate => {
        console.log("iii", itemsToUpdate);
        const localItems = JSON.parse(localStorage.gestordepedidos)
          ? JSON.parse(localStorage.gestordepedidos).docs
          : [];
        const newLocalItems = await localItems.map(item => {
          const itemToUpdate = itemsToUpdate.filter(
            i => i.updateMany.filter._id == item._id
          )[0];
          if (itemToUpdate) {
            return {
              ...item,
              kanban_order: itemToUpdate.updateMany.update.$set.kanban_order,
              status_do_pedido:
                itemToUpdate.updateMany.update.$set.status_do_pedido
            };
          } else {
            return item;
          }
        });
        localStorage.setItem(
          "gestordepedidos",
          JSON.stringify({ docs: newLocalItems })
        );
        return newLocalItems;
      };

      const oldGroup = this.kanbans.filter(
        group => group.name === resIndex.oldGroup
      )[0];
      const newGroup = this.kanbans.filter(
        group => group.name === resIndex.newGroup
      )[0];

      let itensToUpdate = [];
      let newItens = [];

      if (isSameGroup) {
        itensToUpdate = await updateSameGroup(group);
        newItens = await updateLocalItems(itensToUpdate.itemsToBeUpdated);
      } else {
        itensToUpdate = [
          ...(await updateOldGroup(oldGroup, sale)),
          ...(await updateNewGroup(newGroup, sale))
        ];
        newItens = await updateLocalItems(itensToUpdate);
      }
      this.loading = true;
      this.$forceUpdate();
      this.kanbans = this.processKanbanSales(undefined, newItens);
      this.loading = false;
      const payload = {
        ...sale,
        itensToUpdate: isSameGroup
          ? itensToUpdate.itemsToBeUpdated
          : itensToUpdate,
        updateIndexData: resIndex
      };
      this.$forceUpdate();
      this.$run("transacoes/update-status-compra", payload).then(() => {
        // this.listar_gestordepedidos();
        this.$forceUpdate();
        this.$forceUpdate();
      });
    },
    async getElementsFromGroup(group) {
      let newElementsOrder = [];
      for (var i = 0; i < group.length; i++) {
        var elemento = group[i];
        for (var y = 0; y < elemento.childNodes.length; y++) {
          const child = elemento.childNodes[y];
          const id = child.getAttribute ? child.getAttribute("data-id") : null;
          if (id) {
            newElementsOrder.push(id);
          }
        }
      }
      return newElementsOrder;
    },
    async processGroupItems(group, group_name) {
      const newOrderElements = await this.getElementsFromGroup(group);
      return newOrderElements.map((id, index) => {
        return {
          updateMany: {
            filter: { _id: id },
            update: {
              $set: {
                kanban_order: index,
                status_do_pedido: group_name
              }
            }
          }
        };
      });
    },
    getKanbanGroupName(element) {
      if (!element) return "";
      return (
        element.dataset?.kanbanGroup ||
        element.getAttribute("data-kanban-group") ||
        element.getAttribute("group-name") ||
        element.__vue__?.$attrs?.["group-name"] ||
        ""
      );
    },
    getKanbanGroupElements(groupName) {
      return Array.from(document.querySelectorAll("[data-kanban-group]")).filter(
        element => element.getAttribute("data-kanban-group") === groupName
      );
    },
    async updateLocalItems(itemsToUpdate) {
      const localItems = JSON.parse(localStorage.gestordepedidos)
        ? JSON.parse(localStorage.gestordepedidos).docs
        : [];
      const newLocalItems = await localItems.map(item => {
        const itemToUpdate = itemsToUpdate.filter(
          i => i.updateMany.filter._id == item._id
        )[0];
        if (itemToUpdate) {
          return {
            ...item,
            kanban_order: itemToUpdate.updateMany.update.$set.kanban_order,
            status_do_pedido:
              itemToUpdate.updateMany.update.$set.status_do_pedido
          };
        } else {
          return item;
        }
      });
      localStorage.setItem(
        "gestordepedidos",
        JSON.stringify({ docs: newLocalItems })
      );
      return newLocalItems;
    },
    async itemKanbanChange(event, sale, fallbackOldGroupName) {
      if (!event || !event.to || !event.from || !sale || !sale._id) return;
      const new_group_name = this.getKanbanGroupName(event.to);
      const old_group_name =
        this.getKanbanGroupName(event.from) || fallbackOldGroupName || sale.status_do_pedido;
      if (!new_group_name || !old_group_name) return;
      const new_group_items = this.getKanbanGroupElements(new_group_name);
      const old_group_items = this.getKanbanGroupElements(old_group_name);
      const isSameGroup = new_group_name === old_group_name;

      let itensToUpdate = [];
      let newItens = [];

      if (isSameGroup) {
        itensToUpdate = await this.processGroupItems(
          new_group_items,
          new_group_name
        );
      } else {
        itensToUpdate = [
          ...(await this.processGroupItems(new_group_items, new_group_name)),
          ...(await this.processGroupItems(old_group_items, old_group_name))
        ];
      }

      newItens = await this.updateLocalItems(itensToUpdate);
      this.loading = true;
      this.kanbans = this.processKanbanSales(undefined, newItens);
      this.loading = false;
      const payload = {
        _id: sale._id,
        itensToUpdate: itensToUpdate,
        new_group_name: new_group_name,
        old_group_name: old_group_name,
        same_group: isSameGroup
      };
      this.$forceUpdate();
      this.$run("transacoes/update-status-compra", payload).then(() => {
        // this.listar_gestordepedidos();
        this.$forceUpdate();
      });
    },
    openNewKanBanForm() {
      this.new_kanban_form = true;
    },
    getConfigPaymentSys() {
      if (localStorage.payment_sys_config) {
        this.payment_sys_config = JSON.parse(
          localStorage.getItem("payment_sys_config")
        );
      } else {
        this.$store.dispatch("enableLoading");
      }
      this.$run("marketplaces/get-config-payment-sys")
        .then(res => {
          localStorage.setItem(
            "payment_sys_config",
            JSON.stringify(res.data.payment_sys_config)
          );
          this.$store.dispatch("disableLoading");
          this.payment_sys_config = res.data.payment_sys_config;
        })
        .catch(e => {});
    },
    getConfigReceipt() {
      if (localStorage.receipt) {
        this.receipt = JSON.parse(localStorage.getItem("receipt"));
      } else {
        this.$store.dispatch("enableLoading");
      }
      this.$run("marketplaces/get-config-receipt")
        .then(res => {
          localStorage.setItem("receipt", JSON.stringify(res.data.receipt));
          this.$store.dispatch("disableLoading");
          this.receipt = res.data.receipt;
        })
        .catch(e => {});
    },
    createKanban() {
      this.$store.dispatch("enableLoading");
      this.$run("kanban/create", {
        ...this.new_kanban,
        index: this.kanbans.length
      })
        .then(res => {
          this.$store.dispatch("disableLoading");
          this.$store.dispatch("createGlobalMessage", {
            message: "Kanban criado com sucesso",
            type: "success"
          });
          this.new_kanban = {};
          this.new_kanban_form = false;
          this.listKanban();
        })
        .catch(e => {});
    },
    deleteKanban(kanban) {
      this.$store.dispatch("enableLoading");
      this.$run("kanban/delete", kanban)
        .then(() => {
          this.$store.dispatch("disableLoading");
          this.$store.dispatch("createGlobalMessage", {
            message: "Kanban apagado com sucesso",
            type: "success"
          });
          const OldKanbans = JSON.parse(localStorage.kanbans);
          const newKanban = OldKanbans.filter(
            k => k._id !== kanban._id
          );
          // this.kanbans = this.processKanbanSales(newKanban)
          this.kanbans = newKanban;
          localStorage.setItem("kanbans", JSON.stringify(newKanban));
          this.new_kanban = {};
        })
        .catch(e => {});
    },
    salesByKanban(kanban) {
      return this.get_gestordepedidos.docs.filter(
        sale =>
          sale.status_do_pedido.toLowerCase() === kanban.name.toLowerCase()
      );
    },
    processKanbanSales(kanbansPayload, salesPayload) {
      const kanbans = kanbansPayload || JSON.parse(localStorage.kanbans);
      const sales = salesPayload || this.get_gestordepedidos.docs;
      const kanbanSales = kanbans.map(kanban => {
        const salesByKanban = sales.filter(
          sale =>
            sale.status_do_pedido.toLowerCase() === kanban.name.toLowerCase()
        );
        return {
          ...kanban,
          kanbans: this.orderByKey(salesByKanban, "kanban_order")
        };
      });
      return kanbanSales;
    },
    listKanban() {
      if (localStorage.kanbans) {
        this.kanbans = this.processKanbanSales(
          JSON.parse(localStorage.getItem("kanbans"))
        );
      } else {
        this.$store.dispatch("enableLoading");
      }
      this.$run("kanban/list")
        .then(res => {
          localStorage.setItem("kanbans", JSON.stringify(res.data.docs));
          this.$store.dispatch("disableLoading");
          this.kanbans = this.processKanbanSales(res.data.docs);
          this.endDrag();
        })
        .catch(e => {});
    },
    startDrag(event) {
      console.log("start drag", event)
      // this.mouseIsDown = true;
      if (this.dragActive) return;
      const content = document.getElementsByClassName(
        "item-group-kanban-container"
      )[0];
      this.isDragging = true;
      this.startDragX = event.clientX || event.touches[0].clientX;
      this.startScrollLeft = content.scrollLeft;
    },
    drag(event) {
      console.log("drag", event)
      if (this.dragActive || !this.ctrlPressed || !this.mouseIsDown) return;
      if (this.dragActive || !this.mouseIsDown) return;
      const content = document.getElementsByClassName(
        "item-group-kanban-container"
      )[0];
      if (this.isDragging) {
        const scrollAmount =
          this.startScrollLeft +
          (this.startDragX - (event.clientX || event.touches[0].clientX));
        content.scrollLeft = scrollAmount;
      }
    },
    endDrag(event) {
      // console.log("end drag", event)
      // if (this.dragActive) return;
      setTimeout(() => {
        this.isDragging = false;
        this.checking = false;
        // this.mouseIsDown = false;/
      }, 1000);
    },
    handleScroll() {
      if (!this.checking) {
        this.scrolled();
      }
    },
    checkShowButtons() {
      const contentWidth = this.$refs.content.scrollWidth;
      const containerWidth = this.$refs.content.clientWidth;
      const slots = this.$slots.default ? this.$slots.default.length : false;
      const showButtons =
        contentWidth > containerWidth && slots > this.showButtonsAt;
      if (this.showButtons !== showButtons) {
        this.showButtons = showButtons;
      }
    },
    changeKanbanFather(value) {
      const payload = value.moved;
      const orderByIndex = (arr, key) => {
        return arr.sort((a, b) => {
          return a[key] - b[key];
        });
      };
      const OldKanbans = orderByIndex(
        JSON.parse(localStorage.kanbans),
        "index"
      );
      let newKanban = [...OldKanbans];

      newKanban[payload.newIndex] = {
        ...OldKanbans[payload.oldIndex],
        index: payload.newIndex
      };
      newKanban[payload.oldIndex] = {
        ...OldKanbans[payload.newIndex],
        index: payload.oldIndex
      };
      localStorage.setItem("kanbans", JSON.stringify(newKanban));
      this.$run("kanban/update-index", {
        kanbansToUpdate: [
          {
            _id: payload.element._id,
            index: payload.newIndex
          },
          {
            _id: OldKanbans[payload.newIndex]._id,
            index: payload.oldIndex
          }
        ]
      }).then(res => {
        this.listKanban();
      });
    },
    scrollLeft() {
      const element = document.getElementsByClassName(
        "item-group-kanban-container"
      )[0];
      element.scrollBy({ left: -340, behavior: "smooth" });
    },
    scrollRight() {
      const element = document.getElementsByClassName(
        "item-group-kanban-container"
      )[0];
      element.scrollBy({ left: 340, behavior: "smooth" });
    },
    printLote() {
      this.in_printing = true;
      this.$nextTick(() => {
        printBudget({
          elementId: "print-html-lote",
          wrapperId: "imprimir-conteudo-em-lote",
          title: "Propostas",
          delay: 400,
          notify: payload => this.$store.dispatch("createGlobalMessage", payload),
          context: { vuetify: this.$vuetify }
        });
      });
    },
  },
  mounted() {
    EventBus.$on("updateKanban", () => {
      this.listKanban();
    });
    this.saleRealtimeHandler = () => this.handleSaleRealtimeUpdated();
    window.addEventListener("stonepro:sale-updated", this.saleRealtimeHandler);
  },
  created() {
    this.listar_clientes();
    this.listar_gestordepedidos();
    this.getConfigPaymentSys();
    this.getConfigReceipt();
    this.listar_funcionarios();
    this.listKanban();
    this.listar_obras();
    if (this.$route.query.t_id) {
      this.$router.replace(`/gestordepedidos/venda/${this.$route.query.t_id}`);
    }
  },
  beforeDestroy() {
    clearTimeout(this.saleRealtimeRefreshTimer);
    window.removeEventListener("stonepro:sale-updated", this.saleRealtimeHandler);
  }
};
</script>

<style>
.kanban-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  min-width: 100%;
  overflow: hidden;
  right: 0;
  z-index: 1;
}
.item-group-kanban-maximized {
  min-width: 270px;
  max-width: 270px;
}
.item-group-kanban-minimized {
  min-width: 200px;
  max-width: 200px;
}
.item-group-kanban {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #b83d3d;
  border-radius: 10px !important;
  padding-right: 6px;
}
.item-group-kanban-container {
  padding-bottom: 10px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  right: 0;
  z-index: 1;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  touch-action: pan-y;
  min-width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  right: 0;
  z-index: 0;
}
.sortable-chosen {
  background: rgba(0, 0, 0, 0) !important;
  background-color: rgba(0, 0, 0, 0) !important;
  opacity: 1;
}
.max-height-item-kanban {
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.max-height-item-kanban::-webkit-scrollbar {
  width: 8px; /* width of the entire scrollbar */
}

.max-height-item-kanban::-webkit-scrollbar-track {
  background: rgb(235, 233, 233); /* color of the tracking area */
  border-radius: 6px;
}

.max-height-item-kanban::-webkit-scrollbar-thumb {
  background-color: #b3b3b4; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
}
.dragging {
  z-index: 9999;
  position: absolute;
  border-radius: 10px;
  width: 280px;
  rotate: 0deg;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.dropzone {
  transition: background-color 0.3s;
}

.drop-active {
  background-color: #ffaf15;
}

.drop-target {
  background-color: #1173ff;
}

.drag-drop {
  background-color: #f00;
}

.drag-drop.can-drop {
  color: #000;
  background-color: #4e4;
}

.horizontal-scroll {
  position: relative;
  display: flex;
  height: calc(100vh - 45px);
  width: 100%;
  flex-wrap: nowrap;
}

.content-scroll {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  touch-action: pan-y;
  min-width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  right: 0;
  z-index: 0;
  padding-bottom: 10px;
}

.content-scroll::-webkit-scrollbar {
  width: 1px; /* width of the entire scrollbar */
  height: 6px; /* width of the entire scrollbar */
}

.content-scroll::-webkit-scrollbar-track {
  background: rgba(59, 59, 59, 0); /* color of the tracking area */
  border-radius: 6px;
}

.content-scroll::-webkit-scrollbar-thumb {
  background-color: #999797; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
}
.item-group-kanban-container::-webkit-scrollbar {
  width: 1px; /* width of the entire scrollbar */
  height: 14px; /* width of the entire scrollbar */
}

.item-group-kanban-container::-webkit-scrollbar-track {
  background: rgba(75, 74, 74, 0); /* color of the tracking area */
  border-radius: 3px;
}

.item-group-kanban-container::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.5); /* color of the scroll thumb */
  border-radius: 6px; /* roundness of the scroll thumb */
}

.scroll-button {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  font-size: 1rem;
  z-index: 100;
  border: 1px solid #acabab;
  background: rgba(15, 15, 15, 0.5);
}

.left {
  left: 0;
  max-height: 50px;
  min-height: 50px;
  max-width: 50px;
  min-width: 50px;
  border-radius: 50%;
  box-shadow: -1px -2px 60px 2px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: -1px -2px 60px 2px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: -1px -2px 60px 2px rgba(0, 0, 0, 0.1);
  margin-top: 260px;
}

.right {
  right: 0;
  max-height: 50px;
  min-height: 50px;
  max-width: 50px;
  min-width: 50px;
  border-radius: 50%;
  box-shadow: -1px -2px 60px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: -1px -2px 60px 2px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: -1px -2px 60px 2px rgba(0, 0, 0, 0.3);
  margin-top: 260px;
}
.orders-manager-light {
  background: #f7faf8 !important;
  color: #173b33 !important;
}
.orders-manager-dark {
  background: #0b141a !important;
  color: #e9edef !important;
}
.orders-manager-light .item-group-kanban:not(.sale-kanban-column) {
  background: #edf4f0 !important;
  border: 1px solid rgba(7, 80, 89, 0.10);
}
.orders-manager-dark .item-group-kanban:not(.sale-kanban-column) {
  background: #111b21 !important;
  border: 1px solid #26343c;
}
.orders-manager-light .item-group-kanban-container,
.orders-manager-light .content-scroll,
.orders-manager-light .kanban-container {
  background: #f7faf8 !important;
}
.orders-manager-dark .item-group-kanban-container,
.orders-manager-dark .content-scroll,
.orders-manager-dark .kanban-container {
  background: #0b141a !important;
}
.orders-manager-light .v-card,
.orders-manager-light .v-sheet,
.orders-manager-light .v-list,
.orders-manager-light .v-simple-table,
.orders-manager-light table,
.orders-manager-light thead,
.orders-manager-light tbody,
.orders-manager-light tr {
  background: #ffffff !important;
  color: #173b33 !important;
}
.orders-manager-dark .v-card,
.orders-manager-dark .v-sheet,
.orders-manager-dark .v-list,
.orders-manager-dark .v-simple-table,
.orders-manager-dark table,
.orders-manager-dark thead,
.orders-manager-dark tbody,
.orders-manager-dark tr {
  background: #111b21 !important;
  color: #e9edef !important;
  border-color: #26343c !important;
}
.orders-manager-dark th,
.orders-manager-dark td,
.orders-manager-dark span,
.orders-manager-dark h1,
.orders-manager-dark h2,
.orders-manager-dark h3,
.orders-manager-dark h4,
.orders-manager-dark h5,
.orders-manager-dark h6,
.orders-manager-dark .fonte,
.orders-manager-dark .v-label,
.orders-manager-dark .v-input input,
.orders-manager-dark .v-select__selection,
.orders-manager-dark .v-icon {
  color: #e9edef !important;
}
.orders-manager-dark .grey--text {
  color: #8ea39a !important;
}
.orders-manager-dark .v-input__slot,
.orders-manager-dark .v-text-field--filled > .v-input__control > .v-input__slot {
  background: #182229 !important;
  color: #e9edef !important;
}
.orders-manager-light .max-height-item-kanban::-webkit-scrollbar-track,
.orders-manager-light .content-scroll::-webkit-scrollbar-track,
.orders-manager-light .item-group-kanban-container::-webkit-scrollbar-track {
  background: #edf4f0;
}
.orders-manager-light .max-height-item-kanban::-webkit-scrollbar-thumb,
.orders-manager-light .content-scroll::-webkit-scrollbar-thumb,
.orders-manager-light .item-group-kanban-container::-webkit-scrollbar-thumb {
  background: #b9c9c1;
}
.orders-manager-dark .max-height-item-kanban::-webkit-scrollbar-track,
.orders-manager-dark .content-scroll::-webkit-scrollbar-track,
.orders-manager-dark .item-group-kanban-container::-webkit-scrollbar-track {
  background: #0b141a;
}
.orders-manager-dark .max-height-item-kanban::-webkit-scrollbar-thumb,
.orders-manager-dark .content-scroll::-webkit-scrollbar-thumb,
.orders-manager-dark .item-group-kanban-container::-webkit-scrollbar-thumb {
  background: #40515a;
}
.new-kanban-column {
  height: calc(100vh - 76px);
  min-height: calc(100vh - 76px);
  max-height: calc(100vh - 76px);
  width: 100%;
  border-radius: 20px !important;
  padding: 10px !important;
  border: 1px solid transparent;
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}
.new-kanban-slot {
  box-sizing: border-box;
  flex: 0 0 auto;
}
.new-kanban-column-light {
  background:
    radial-gradient(circle at top left, rgba(37, 211, 102, 0.10), transparent 38%),
    rgba(237, 244, 240, 0.92) !important;
  border-color: rgba(7, 80, 89, 0.12) !important;
  box-shadow: 0 18px 34px rgba(7, 80, 89, 0.08);
}
.new-kanban-column-dark {
  background:
    radial-gradient(circle at top left, rgba(37, 211, 102, 0.08), transparent 38%),
    #111b21 !important;
  border-color: #26343c !important;
  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.24);
}
.new-kanban-action {
  width: 100%;
  min-height: 96px;
  border: 1px dashed rgba(7, 80, 89, 0.26);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.62);
  color: #173b33;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  text-align: left;
  cursor: pointer;
  transition: transform 0.18s ease, background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}
.new-kanban-action:hover {
  transform: translateY(-2px);
  background: #ffffff;
  border-color: rgba(7, 80, 89, 0.42);
  box-shadow: 0 14px 28px rgba(7, 80, 89, 0.10);
}
.new-kanban-column-dark .new-kanban-action {
  background: #182229;
  border-color: #314249;
  color: #e9edef;
}
.new-kanban-column-dark .new-kanban-action:hover {
  background: #223139;
  border-color: #3d5863;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.30);
}
.new-kanban-icon {
  width: 38px;
  height: 38px;
  border-radius: 14px;
  background: linear-gradient(135deg, #075e54, #128c7e);
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 10px 20px rgba(7, 94, 84, 0.24);
}
.new-kanban-icon .v-icon {
  color: #ffffff !important;
}
.new-kanban-copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.new-kanban-copy strong,
.new-kanban-form strong {
  color: #173b33;
  font-size: 14px;
}
.new-kanban-copy small,
.new-kanban-form small {
  color: #667781;
  font-size: 11px;
  line-height: 1.25;
}
.new-kanban-column-dark .new-kanban-copy strong,
.new-kanban-column-dark .new-kanban-form strong {
  color: #e9edef;
}
.new-kanban-column-dark .new-kanban-copy small,
.new-kanban-column-dark .new-kanban-form small {
  color: #8ea39a;
}
.new-kanban-form {
  width: 100%;
  padding: 10px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.68);
  border: 1px solid rgba(7, 80, 89, 0.12);
}
.new-kanban-column-dark .new-kanban-form {
  background: #182229;
  border-color: #314249;
}
.new-kanban-form-body {
  gap: 10px;
  padding: 0 !important;
}
.new-kanban-form-body::before {
  content: "Criar fluxo";
  align-self: flex-start;
  color: #173b33;
  font-weight: 800;
  font-size: 14px;
  margin-bottom: -4px;
}
.new-kanban-column-dark .new-kanban-form-body::before {
  color: #e9edef;
}
.new-kanban-color-picker {
  border-radius: 16px !important;
  overflow: hidden;
  max-width: 100%;
  box-shadow: none !important;
}
.new-kanban-actions {
  gap: 8px;
}
.new-kanban-form .v-btn {
  border-radius: 12px !important;
}
.new-kanban-column-light .new-kanban-form .v-btn:not(.new-kanban-submit) {
  color: #075e54 !important;
}
.new-kanban-column-dark .new-kanban-form .v-btn:not(.new-kanban-submit) {
  color: #e9edef !important;
}
.new-kanban-form .v-btn:last-child {
  background: linear-gradient(135deg, #075e54, #128c7e) !important;
  color: #ffffff !important;
  border-color: transparent !important;
}
.new-kanban-submit {
  background: linear-gradient(135deg, #075e54, #128c7e) !important;
  color: #ffffff !important;
  border-radius: 12px !important;
}
.kanban-column-chosen {
  transform: scale(1.015);
}
.kanban-column-dragging {
  transform: rotate(1deg) scale(1.02);
  opacity: 0.92;
  filter: drop-shadow(0 22px 32px rgba(0, 0, 0, 0.24));
}
.kanban-ghost- {
  opacity: 0.42 !important;
  transform: scale(0.98);
}
.kanban-board-drag-active .sale-kanban-column,
.kanban-board-drag-active .new-kanban-column {
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}
.kanban-board-drag-active .sale-kanban-column:hover,
.kanban-board-drag-active .new-kanban-column:hover {
  transform: translateY(-3px);
}
</style>
